/**
 * Created by Administrador on 24/10/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('customerCorporateOperations', {
                parent: 'app',
                url: '/customerCorporateReport/customerCorporateOperations',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/customerCorporateReport/customerCorporateOperations.html',
                        controller: 'customerCorporateReportCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['customerCorporateReport']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCustomerCorporateReport('customerCorporateOperations')
                            }],
                            parents: ['customerCorporateService',function(customerCorporateService){
                                return customerCorporateService.getParents()
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('ownOperations', {
                parent: 'app',
                url: '/customerCorporateReport/ownOperations',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/customerCorporateReport/customerCorporateOwnOperations.html',
                        controller: 'customerCorporateOwnOperationsReportCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['customerCorporateReport']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCustomerCorporateReport('ownOperations')
                            }],
                            userSession: ['userService', function (userService) {
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
            .state('reportKardex', {
                parent: 'app',
                url: '/customerCorporateReport/reportKardex',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/customerCorporateReport/customerCorporateReportKardex.html',
                        controller: 'customerCorporateReportKardexCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['customerCorporateReport']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabCustomerCorporateReport('reportKardex')
                            }],
                            parents: ['customerCorporateService',function(customerCorporateService){
                                return customerCorporateService.getParents()
                            }],
                            userSession: ['userService', function (userService) {
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            });
    }
})();
